export const navigation = () => ({
  menu: {
    show: false,
    activeIndex: undefined,
    onResize() {
      this.menu.show = false;
    },
  },
  search: {
    show: false,
    init: false,
    toggle() {
      if (this.search.show) {
        this.search.close();
      } else {
        this.search.open();
      }
    },
    open(event: MouseEvent) {
      this.search.init = true;
      if (this.search.show === false) {
        event.preventDefault();
        this.search.show = true;
        this.$nextTick(() => {
          this.$refs.search.focus();
        });
      }
    },
    close() {
      this.search.show = false;
    },
  },
});
